import React from 'react';
import { observer } from 'mobx-react';
import { useLocalStore } from '../local-store-provider/LocalStoreProvider.utils';
import { RevenueCalculatorStore } from '../revenue-calculator/RevenueCalculator.store';
import { Grid } from '@mui/material';
import { FormInput } from './form-input/FormInput';
import { NumberFormatValues } from 'react-number-format';

interface IProps {
  windowWidth: number;
}

export const FormFields: React.FC<IProps> = observer((props) => {
  const localStore = useLocalStore<RevenueCalculatorStore>();
  const isSmall = props.windowWidth < 800;

  return (
    <Grid
      container={true}
      item={true}
      marginBottom={4}
    >
      <FormInput
        inputLabel={'Starting Annual Revenue'}
        value={localStore.startingAnnualRevenue}
        prefix={'$'}
        paddingRight={isSmall ? 0 : 1}
        onValueChange={(values: NumberFormatValues) => localStore.updateStartingAnnualRevenue(values.floatValue ?? 0)}
      />
      <FormInput
        inputLabel={'Average Hourly Bill Rate'}
        value={localStore.averageHourlyBillRate}
        prefix={'$'}
        isSecond={true}
        paddingLeft={isSmall ? 0 : 1}
        onValueChange={(values: NumberFormatValues) => localStore.updateAverageHourlyBillRate(values.floatValue ?? 0)}
      />
      <FormInput
        inputLabel={'Number of Billable Employees'}
        value={localStore.billableEmployeeCount}
        paddingRight={isSmall ? 0 : 1}
        onValueChange={(values: NumberFormatValues) => localStore.updateEmployeeCount(values.floatValue ?? 0)}
      />
      <FormInput
        inputLabel={'Percent Billable Target'}
        value={localStore.billableEmployeeUtilizationTarget}
        isSecond={true}
        suffix={'%'}
        paddingLeft={isSmall ? 0 : 1}
        onValueChange={(values: NumberFormatValues) => localStore.updateEmployeeBillableTarget(values.floatValue ?? 0)}
      />
      <FormInput
        inputLabel={'Number of Non-billable Employees'}
        value={localStore.nonBillEmployeeCount}
        paddingRight={isSmall ? 0 : 1}
        onValueChange={(values: NumberFormatValues) => localStore.updateNonBillEmployeeCount(values.floatValue ?? 0)}
      />
      <Grid
        item={true}
        sm={6}
        xs={0}
      >
        &nbsp;
      </Grid>
      <FormInput
        inputLabel={'Average Working Hours per Week'}
        inputLabelSub={'(billable + non-billable)'}
        value={localStore.averageWorkingHoursPerWeek}
        paddingRight={isSmall ? 0 : 1}
        onValueChange={(values: NumberFormatValues) => localStore.updateWorkingHoursPerWeek(values.floatValue ?? 0)}
      />
      <FormInput
        inputLabel={'Average PTO Days per Year'}
        inputLabelSub={'(excluding weekends)'}
        isSecond={true}
        paddingLeft={isSmall ? 0 : 1}
        value={localStore.averagePtoDaysPerYear}
        onValueChange={(values: NumberFormatValues) => localStore.updateAveragePtoDays(values.floatValue ?? 0)}
      />
    </Grid>
  );
});
